/**
 * =============================================================================
 * product-form.js
 * =============================================================================
 * Manage state of a single product form
 * =============================================================================
 */

import VariantStateManager from './variant-state-manager'

class ProductForm {
  container;
  form;

  variantStateManager;
  swiperMedia; // Injected in a pre init callback from product-media.liquid
  swiperThumbs; // Injected in a pre init callback from product-media.liquid

  constructor(container) {
    this.container = container;

    this.form = this.container.querySelector('.product-form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

    let variantSelect = this.container.querySelector("#variant-select");
    let sellingPlanSelect = this.container.querySelector("#selling-plan-select");
    this.variantStateManager = new VariantStateManager(this.container, variantSelect, sellingPlanSelect);

    this.container.addEventListener('variant:changed', this.onVariantChanged.bind(this));
  }

  onSubmitHandler(e) {
    e.preventDefault();

    // Prevent further submissions if we're in the middle of one already
    const submitButton = this.form.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) return;

    // Update visual state as we process the submission. There might be multiple
    // add buttons on the page - this disables them all.
    this.container.querySelectorAll('[data-disable-on-add]').forEach(element => {
      element.classList.add('loading');
      element.setAttribute('aria-disabled', true);
    });
    this.container.querySelectorAll('.spinner-overlay').forEach(element => element.classList.remove('d-none'));

    // Construct the submission body - this uses FormData, which will get every
    // form field in the form (including 'properties')
    const formData = new FormData(this.form);
    formData.append('sections_url', window.location.pathname);

    // Add the submitted product to the cart
    MP.Extensions.Cart.add(formData).finally(e => {
      this.container.querySelectorAll('[data-disable-on-add]').forEach(element => {
        element.classList.remove('loading');
        element.removeAttribute('aria-disabled');
      });
      
      this.container.querySelectorAll('.spinner-overlay').forEach(element => element.classList.add('d-none'));
    });
  }

  onVariantChanged(e) {
    console.log('[P-F] Variant changed on this product form');
    const variant = this.variantStateManager.currentVariant;

    // Update Swiper current slide
    const matchingSlide = this.container.querySelector(`[data-variants*='${variant.id}']:not(.swiper-slide-duplicate)`);
    if (matchingSlide) {
      const slideIndex = matchingSlide.dataset.index;
      if (slideIndex) {
        this.swiperMedia.slideToLoop(parseInt(slideIndex));
      }
    }

    // Update Klarna
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
  }

  handleErrorMessage(message) {
    MP.Utilities.toast("warning", message, "fal fa-exclamation-triangle");
  }
}

export default ProductForm;